<template>
  <v-container fluid grid-list-xl class="mt-5">
    <v-layout justify-center wrap>
      <v-flex md12 lg6 v-if="isAdmin">
        <material-card
          color="orange"
          title="Expiring Companies"
          text="Companies with software expiration date less than 1 month"
        >
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Name</th>
                  <th class="text-left">Installed On</th>
                  <th class="text-left">Remaining Days</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in expiringList" :key="item.subdomain">
                  <td>{{ item.subdomain }}</td>
                  <td>{{ item.softwareinstallationdate }}</td>
                  <td>{{ item.remainingdays }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </material-card>
      </v-flex>
      <v-flex md12 lg6 v-if="isAdmin">
        <material-card
          color="red"
          title="Expired Companies"
          text="Companies expired and not renewed yet"
        >
          <v-simple-table>
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-left">Name</th>
                  <th class="text-left">Installed On</th>
                  <th class="text-left">Expired Days</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in expiredList" :key="item.subdomain">
                  <td>{{ item.subdomain }}</td>
                  <td>{{ item.softwareinstallationdate }}</td>
                  <td>{{ item.expireddays }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </material-card>
      </v-flex>
      <v-flex xs12 sm3 md3 v-if="summary != null">
        <v-card color="green" dark @click="goto('present')">
          <v-card-title>{{ $t("language.present") }}</v-card-title>
          <v-card-text>{{ summary.present ? summary.present : 0 }}</v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm3 md3 v-if="summary != null">
        <v-card color="red" dark @click="goto('absent')">
          <v-card-title>{{ $t("language.absent") }}</v-card-title>
          <v-card-text>{{ summary.absent ? summary.absent : 0 }}</v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm3 md3 v-if="summary != null">
        <v-card color="orange" dark @click="goto('leave')">
          <v-card-title>{{ $t("language.leave") }}</v-card-title>
          <v-card-text>{{ summary.leave ? summary.leave : 0 }}</v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm3 md3 v-if="summary != null">
        <v-card color="blue" dark @click="goto('officialvisit')">
          <v-card-title>{{ $t("language.officialvisit") }}</v-card-title>
          <v-card-text>{{
            summary.officialvisit ? summary.officialvisit : 0
          }}</v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm3 md3 v-if="summary != null">
        <v-card color="cyan" dark @click="goto('weekend')">
          <v-card-title>{{ $t("language.weekend") }}</v-card-title>
          <v-card-text>{{ summary.weekend ? summary.weekend : 0 }}</v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm3 md3 v-if="summary != null">
        <v-card color="brown" dark @click="goto('lateinearlyout')">
          <v-card-title>{{ $t("language.latein") }}</v-card-title>
          <v-card-text>{{ summary.latein ? summary.latein : 0 }}</v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 sm3 md3 v-if="summary != null">
        <v-card color="amber" dark @click="goto('lateinearlyout')">
          <v-card-title>{{ $t("language.earlyout") }}</v-card-title>
          <v-card-text>{{
            summary.earlyout ? summary.earlyout : 0
          }}</v-card-text>
        </v-card>
      </v-flex>
      <v-flex md12 lg12 v-if="showBranchesSummary">
        <v-expansion-panels v-model="panel" multiple focusable>
          <v-expansion-panel>
            <v-expansion-panel-header>{{
              $t("language.branchsummary")
            }}</v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card-text>
                <v-simple-table>
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">{{ $t("language.branch") }}</th>
                        <th class="text-left">{{ $t("language.present") }}</th>
                        <th class="text-left">{{ $t("language.absent") }}</th>
                        <th class="text-left">{{ $t("language.leave") }}</th>
                        <th class="text-left">
                          {{ $t("language.officialvisit") }}
                        </th>
                        <th class="text-left">{{ $t("language.weekend") }}</th>
                        <th class="text-left">{{ $t("language.latein") }}</th>
                        <th class="text-left">{{ $t("language.earlyout") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="item in branchessummary" :key="item.id">
                        <td>{{ item.name }}</td>
                        <td>
                          <a @click="goto('present', item.id)">
                            {{ item.present ? item.present : 0 }}
                          </a>
                        </td>
                        <td>
                          <a @click="goto('absent', item.id)">
                            {{ item.absent ? item.absent : 0 }}
                          </a>
                        </td>
                        <td>
                          <a @click="goto('leave', item.id)">
                            {{ item.leave ? item.leave : 0 }}
                          </a>
                        </td>
                        <td>
                          <a @click="goto('officialvisit', item.id)">
                            {{ item.officialvisit ? item.officialvisit : 0 }}
                          </a>
                        </td>
                        <td>
                          <a @click="goto('weekend', item.id)">
                            {{ item.weekend ? item.weekend : 0 }}
                          </a>
                        </td>
                        <td>
                          <a @click="goto('lateinearlyout', item.id)">
                            {{ item.latein ? item.latein : 0 }}
                          </a>
                        </td>
                        <td>
                          <a @click="goto('lateinearlyout', item.id)">
                            {{ item.earlyout ? item.earlyout : 0 }}
                          </a>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-flex>
      <v-flex x12 sm12 md12 v-if="calendardata != null">
        <v-card>
          <v-card-title>
            <v-icon @click="prevMonth()">keyboard_arrow_left</v-icon>
            <span style="margin: 0 auto"
              >{{ currentMonthName }} {{ currentYear }}</span
            >
            <v-icon @click="nextMonth()">keyboard_arrow_right</v-icon>
          </v-card-title>
          <v-card-text>
            <table class="calendar">
              <thead>
                <tr>
                  <th>{{ $t("language.sun") }}</th>
                  <th>{{ $t("language.mon") }}</th>
                  <th>{{ $t("language.tue") }}</th>
                  <th>{{ $t("language.wed") }}</th>
                  <th>{{ $t("language.thu") }}</th>
                  <th>{{ $t("language.fri") }}</th>
                  <th>{{ $t("language.sat") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td v-html="generateCalendarData(1, 1)"></td>
                  <td v-html="generateCalendarData(1, 2)"></td>
                  <td v-html="generateCalendarData(1, 3)"></td>
                  <td v-html="generateCalendarData(1, 4)"></td>
                  <td v-html="generateCalendarData(1, 5)"></td>
                  <td v-html="generateCalendarData(1, 6)"></td>
                  <td v-html="generateCalendarData(1, 7)"></td>
                </tr>
                <tr>
                  <td v-html="generateCalendarData(2, 1)"></td>
                  <td v-html="generateCalendarData(2, 2)"></td>
                  <td v-html="generateCalendarData(2, 3)"></td>
                  <td v-html="generateCalendarData(2, 4)"></td>
                  <td v-html="generateCalendarData(2, 5)"></td>
                  <td v-html="generateCalendarData(2, 6)"></td>
                  <td v-html="generateCalendarData(2, 7)"></td>
                </tr>
                <tr>
                  <td v-html="generateCalendarData(3, 1)"></td>
                  <td v-html="generateCalendarData(3, 2)"></td>
                  <td v-html="generateCalendarData(3, 3)"></td>
                  <td v-html="generateCalendarData(3, 4)"></td>
                  <td v-html="generateCalendarData(3, 5)"></td>
                  <td v-html="generateCalendarData(3, 6)"></td>
                  <td v-html="generateCalendarData(3, 7)"></td>
                </tr>
                <tr>
                  <td v-html="generateCalendarData(4, 1)"></td>
                  <td v-html="generateCalendarData(4, 2)"></td>
                  <td v-html="generateCalendarData(4, 3)"></td>
                  <td v-html="generateCalendarData(4, 4)"></td>
                  <td v-html="generateCalendarData(4, 5)"></td>
                  <td v-html="generateCalendarData(4, 6)"></td>
                  <td v-html="generateCalendarData(4, 7)"></td>
                </tr>
                <tr>
                  <td v-html="generateCalendarData(5, 1)"></td>
                  <td v-html="generateCalendarData(5, 2)"></td>
                  <td v-html="generateCalendarData(5, 3)"></td>
                  <td v-html="generateCalendarData(5, 4)"></td>
                  <td v-html="generateCalendarData(5, 5)"></td>
                  <td v-html="generateCalendarData(5, 6)"></td>
                  <td v-html="generateCalendarData(5, 7)"></td>
                </tr>
              </tbody>
            </table>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";
import store from "../store";
import commonservice from "../shared/common.service";
export default {
  name: "Dashboard",
  data() {
    return {
      panel: [1],
      currentMonth: commonservice.getCurrentMonth(),
      currentYear: commonservice.getCurrentYear(),
      branchessummary: [],

      isAdmin: store.getters.company.name == undefined,
      expiringList: [],
      expiredList: [],
      showBranchesSummary: false,
      summary: null,
      calendardata: null,
    };
  },
  computed: {
    currentMonthName() {
      return commonservice.getMonthName(this.currentMonth);
    },
  },
  beforeRouteEnter(to, from, next) {
    // let url = "dashboard?year=" + commonservice.getCurrentYear() + "&month=" + commonservice.getCurrentMonth()
    // axios.get(url).then((response) => {
    //   next((p) => {
    //     p.isAdmin = response.data.isAdmin;
    //     p.expiringList = response.data.expiringList;
    //     p.expiredList = response.data.expiredList;
    //     p.showBranchesSummary = response.data.showBranchesSummary;
    //     p.summary = response.data.summary;
    //     p.calendardata = response.data.calendardata;
    //   });
    // });
    if (store.getters.company.name == undefined) {
      Promise.all([
        axios.get("admin/dashboard/expiringcompanies"),
        axios.get("admin/dashboard/expiredcompanies"),
      ]).then((response) => {
        next((p) => {
          p.expiringList = response[0].data;
          p.expiredList = response[1].data;
        });
      });
    } else {
      var promises = [];
      if (store.getters.role != "USER") {
        promises.push(axios.get("client/dashboard/summary"));
      }
      if (
        store.getters.role != "SUPERADMIN" &&
        store.getters.role != "DEALER"
      ) {
        promises.push(
          axios.get(
            "client/dashboard/monthlystatus?year=" +
              commonservice.getCurrentYear() +
              "&month=" +
              commonservice.getCurrentMonth()
          )
        );
      }
      if (promises.length > 0) {
        Promise.all(promises).then((response) => {
          next((p) => {
            if (store.getters.role == "USER") {
              p.calendardata = response[0].data;
            } else {
              p.summary = response[0].data;
              p.showBranchesSummary = true;
              if (
                store.getters.role != "SUPERADMIN" &&
                store.getters.role != "DEALER"
              ) {
                p.calendardata = response[1].data;
              }
            }
          });
        });
      } else {
        next();
      }
    }
  },
  methods: {
    generateCalendarData(weekofmonth, dayofweek) {
      var data = this.calendardata.find((item) => {
        return item.weekofmonth == weekofmonth && item.dayofweek == dayofweek;
      });
      if (data != null)
        return (
          "<div class='day'>" +
          data.day +
          "</div><div class='daystatus'>" +
          data.statusshorttext +
          "</div>"
        );
      return "";
    },
    prevMonth() {
      if (this.currentMonth == 1) {
        this.currentYear = this.currentYear - 1;
        this.currentMonth = 12;
      } else this.currentMonth = this.currentMonth - 1;
      this.loadCalendar();
    },
    nextMonth() {
      if (this.currentMonth == 12) {
        this.currentYear = this.currentYear + 1;
        this.currentMonth = 1;
      } else this.currentMonth = this.currentMonth + 1;
      this.loadCalendar();
    },
    loadCalendar() {
      if (
        store.getters.role != "SUPERADMIN" &&
        store.getters.role != "DEALER"
      ) {
        axios
          .get(
            "client/dashboard/monthlystatus?year=" +
              this.currentYear +
              "&month=" +
              this.currentMonth
          )
          .then((response) => {
            this.calendardata = response.data;
          });
      }
    },
    loadBranchesSummary() {
      axios.get("client/dashboard/branches/summary").then((response) => {
        this.branchessummary = response.data;
      });
    },
    goto(type, branchid) {
      this.$router.push(
        "/report/daily/attendance?type=" +
          type +
          (branchid != null ? "&branchid=" + branchid : "")
      );
    },
  },
  watch: {
    panel() {
      if (this.branchessummary.length == 0) this.loadBranchesSummary();
    },
  },
};
</script>
